/**
 * TierBadge Component
 * Displays "PRO" or "PREMIUM" badge for tier-gated features.
 * Replaces inline <span>PRO</span> patterns throughout the app.
 */

import type { GatedFeature } from '@parlay-picker/shared/featureAccess';
import { getRequiredTier } from '@parlay-picker/shared/featureAccess';
import { TIER_DISPLAY_NAMES } from '@parlay-picker/shared/subscriptionTier';
import type { ReactElement } from 'react';

interface TierBadgeProps {
  feature: GatedFeature;
  size?: 'sm' | 'md';
}

export function TierBadge({ feature, size = 'sm' }: TierBadgeProps): ReactElement {
  const tier = getRequiredTier(feature);
  const label = TIER_DISPLAY_NAMES[tier].toUpperCase();

  const sizeClasses = size === 'sm' ? 'text-[9px] px-1 py-0.5' : 'text-[10px] px-1.5 py-0.5';

  return (
    <span className={`${sizeClasses} font-semibold rounded bg-theme-primary/20 text-theme-primary`}>
      {label}
    </span>
  );
}
